<!-- @format -->

<section
	id="pdp-color-attributes"
	class="color-attributes-container">
	@if (!isColorBucket()) {
		<pdp-attributes-components-label [attributeGroupName]="'Color'">
		</pdp-attributes-components-label>
	}

	<div class="sliding-row-outer">
		<div class="sliding-row-inner hmf-grid hmf-pb-xs">
			<hmf-selectable
				class="hmf-mr-xxs hmf-mb-m-xxs hmf-mb-0 hmf-mt-m-0 hmf-mt-xxxs"
				[options]="colorAttributesSelectableOptions()"
				[multipleSelection]="false"
				[allowDeselection]="false"
				variant="image"
				width="82px"
				height="82px"
				(selectionChange)="selectedAttributeChange($event)"
				[flexWrap]="!isMobile()" />
		</div>
	</div>
</section>
